import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { setLoading } from "../../features/authSlice";
import { getBlog } from "../../api/blogApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { Box, Typography } from "@mui/material";
import theme from "../../theme";
import moment from "moment";

const IndividualBlog = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.auth);
    const [blog, setBlog] = useState(null);

    const getBlogData = async () => {
        try {
            if (location.pathname.split('/')[2]) {
                dispatch(setLoading({
                    loading: true
                }));
                const response = await getBlog(location.pathname.split('/')[2]);
                setBlog(response.data);
                if (response.data.thumbnail_url) {
                    const responseData = await fetch(`${process.env.REACT_APP_BASE_URL}/file?bname=${response.data.thumbnail_url}&download=false`, {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    });

                    if (!responseData.ok) {
                        throw new Error('Failed to fetch image');
                    }

                    const blob = await responseData.blob();
                    response.data.image = URL.createObjectURL(blob);
                    setBlog(response.data);
                }
                dispatch(setLoading({
                    loading: false
                }));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getBlogData();
    }, [location.pathname]);

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <Box width="80%" margin="20px auto">
                <Typography fontSize={22} fontWeight={600} mb={2} color={theme.palette.secondary.main}>{blog?.title}</Typography>
                {blog?.image ? (
                    <img
                        src={blog?.image}
                        alt={blog?.short_description || "blog"}
                        style={{
                            width: '100%',
                            height: '400px',
                            display: 'block'
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: '100%',
                            height: '300px',
                            bgcolor: 'grey.200',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Typography color="text.secondary">Loading image...</Typography>
                    </Box>
                )}
                <Typography mt={1} fontSize={16}>{blog?.short_description}</Typography>
                <Typography
                    component="div"
                    dangerouslySetInnerHTML={{ __html: blog?.content }}
                />
                <Typography fontSize={16} >Published At: {moment(blog?.published_at).format('MMM DD, YYYY')}</Typography>
                <Typography mt={1} fontSize={16}>Published by: <span style={{ fontWeight: 600 }}>{blog?.author_name}</span></Typography>
            </Box>
        </Fragment >
    )
}

export default IndividualBlog;